export const isBrowserNotificationSupported = () => {
  return typeof window !== 'undefined' && 'Notification' in window;
};

export const getBrowserNotificationStatus = () => {
  if (typeof window === 'undefined') return 'unavailable';
  if (!window.isSecureContext) return 'insecure_context';
  if (!isBrowserNotificationSupported()) return 'unsupported';
  return Notification.permission;
};

export const requestBrowserNotificationPermission = async () => {
  if (!isBrowserNotificationSupported()) return 'unsupported';

  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';

  try {
    return await Notification.requestPermission();
  } catch (error) {
    return 'default';
  }
};

export const htmlToText = (html) => {
  if (!html || typeof html !== 'string') return '';
  if (typeof DOMParser === 'undefined') return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const text = doc?.body?.textContent || '';
  return text.replace(/\s+/g, ' ').trim();
};

export const showBrowserNotification = ({ title, body, onClick, tag }) => {
  if (!isBrowserNotificationSupported()) {
    return { shown: false, reason: 'unsupported' };
  }
  if (typeof window !== 'undefined' && !window.isSecureContext) {
    return { shown: false, reason: 'insecure_context' };
  }
  if (Notification.permission !== 'granted') {
    return { shown: false, reason: `permission_${Notification.permission}` };
  }

  try {
    const notification = new Notification(title || 'Новое уведомление', {
      body: body || '',
      icon: '/aihublogo.png',
      badge: '/aihublogo.png',
      tag: tag || undefined
    });

    if (typeof onClick === 'function') {
      notification.onclick = (event) => {
        event.preventDefault();
        onClick();
      };
    }

    return { shown: true, notification };
  } catch (error) {
    return { shown: false, reason: 'error', error };
  }
};
